export type Group = {
  groupName: string;
  joinType: string;
  ownerUid: string;
  adminUids?: string[];
  memberUids?: string[];
  requestUids?: string[];
  bannedUids?: string[];
};

export const getGroupMemberCount = (group: Group) => {
  return group.memberUids?.length;
};

export const getAllUserIdsStoredInGroup = (group: Group) => {
  return (group.memberUids ?? [])
    .concat(group.bannedUids ?? [])
    .concat(group.requestUids ?? []);
};

export const getGroupRegularUserIds = (group: Group) => {
  return group.memberUids?.filter(
    (uid) => uid !== group.ownerUid && (!group.adminUids?.includes(uid) ?? true)
  );
};

export const groupApproveRequest = (group: Group, uid: string) => {
  group.requestUids = group.requestUids?.filter((u) => u !== uid);
  if (!group.memberUids) {
    group.memberUids = [uid];
  } else if (!group.memberUids.includes(uid)) {
    group.memberUids.push(uid);
  }
};

export const groupRejectRequest = (group: Group, uid: string) => {
  group.requestUids = group.requestUids?.filter((u) => u !== uid);
};

export const groupRemoveUser = (group: Group, uid: string) => {
  group.memberUids = group.memberUids?.filter((u) => u !== uid);
  group.adminUids = group.adminUids?.filter((u) => u !== uid);
  group.requestUids = group.requestUids?.filter((u) => u !== uid);
};

export const groupBanUser = (group: Group, uid: string) => {
  groupRemoveUser(group, uid);

  if (!group.bannedUids) {
    group.bannedUids = [uid];
  } else if (!group.bannedUids.includes(uid)) {
    group.bannedUids.push(uid);
  }
};

export const groupUnbanUser = (group: Group, uid: string) => {
  group.bannedUids = group.bannedUids?.filter((u) => u !== uid);
};

export const groupAddAdmin = (group: Group, uid: string) => {
  if (!group.adminUids) {
    group.adminUids = [uid];
  } else if (!group.adminUids.includes(uid)) {
    group.adminUids.push(uid);
  }
};

export const groupRemoveAdmin = (group: Group, uid: string) => {
  group.adminUids = group.adminUids?.filter((u) => u !== uid);
};
